export const usersTenants = {
  TYPE_ADMIN: 1,
  TYPE_USER: 2,
  TYPE_SUPERVISOR: 3,
  TYPE_TECHNICIAN: 4,
};

export const classesPeriods = {
  MORNING: 1,
  AFTERNOON: 2,
  NIGHT: 3,
  FULLTIME: 4,
}

export const userType = {
  TYPE_SYSTEM: 1,
  TYPE_ADMIN: 2,
  TYPE_SUPPORT: 3,
  TYPE_USER: 4,
  TYPE_INSTRUCTOR: 5,
};

export const courseFilesType = {
  TYPE_CLASS: 1,
  TYPE_THEORETICAL: 2,
  TYPE_PRATICAL: 3
}

export const classesStatus = {
  TYPE_PLANNED: 1,
  TYPE_IN_PROGRESS: 2,
  TYPE_CLOSED: 3,
  TYPE_FINISHED: 4,
  TYPE_CANCELED: 5,
}

export const statusClassStudent = {
  TYPE_APPROVED: 1,
  TYPE_ABSENT: 2,
  TYPE_INSUFFICIENCY: 3
}

export const paymentMethodsType = {
  TYPE_METHOD_CREDIT: 2,
}
